import Grid from '@highcharts/grid-pro';

/**
 * Grid Pro v3 licenses via `Grid.setOptions({ gridKey })` in {@link configureGridPro}
 * (see `projects/jepto/src/main.ts`). The older
 * `LicenseValidationComposition.js` side-effect import is not shipped in `@highcharts/grid-pro` v3.
 */

/** Grid Pro extends core Options via module augmentation (not in the package entry types). */
declare module '@highcharts/grid-pro/es-modules/Grid/Core/Options' {
	interface Options {
		gridKey?: string;
	}
}

let configured = false;

export interface ConfigureGridProOptions {
	/** Grid Pro license key from https://shop.highcharts.com (not the license ID). */
	gridKey?: string;
}

/**
 * Applies global Highcharts Grid Pro options once per page load.
 * Call from app bootstrap (e.g. `main.ts`) with the env-specific Grid Key.
 */
export function configureGridPro(options: ConfigureGridProOptions = {}): void {
	if (configured && !options.gridKey) {
		return;
	}

	const gridKey = options.gridKey?.trim();
	if (gridKey) {
		Grid.setOptions({ gridKey });
	}

	configured = true;
}
